import { ReactNode } from 'react';
import { SkeletonTheme, SkeletonThemeProps } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

type Props = { children: ReactNode } & SkeletonThemeProps;

export const SkeletonProvider = ({
  children,
  baseColor = 'var(--border-default)',
  highlightColor = 'var(--surface-secondary)',
  ...props
}: Props) => {
  return (
    <SkeletonTheme
      baseColor={baseColor}
      highlightColor={highlightColor}
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </SkeletonTheme>
  );
};
